import { useEffect, useState } from "react";
import Navbar from "../navbar/navbar";
import Datatable from "../../datatable/Datatable";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { FaCheckCircle, FaEdit, FaTimesCircle, FaTrash } from "react-icons/fa";
import { createGotra, deleteGotra, deleteNakshatra, getGotraById, getGotraMasterList, updateGotra } from "../../services/admin.service";
import AlertConfirmation from "../../common/AlertConfirmation.component";
import "../admin/adminModule.css";

const GotraMasterListComponent = () => {

    const [gotraMasterList, setGotraMasterList] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editData, setEditData] = useState(null);
    const loginId = Number(localStorage.getItem('loginId'));

    useEffect(() => {
        fetchGotraList();
    }, []);

    const fetchGotraList = async () => {
        try {
            const response = await getGotraMasterList();
            if (response) {
                setGotraMasterList(response);
            } else {
                Swal.fire("Error", "Failed to fetch Gotra list", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching Gotra list", "error");
            console.error(error);
        }
    };

    const validationSchema = Yup.object().shape({
        gotraName: Yup.string().required("Gotra Name is required"),
    });

    const initialValues = {
        gotraName: editData?.gotraName || "",
    };

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Gotra Name", selector: (row) => row.gotraName, sortable: true, align: 'text-start' },
        { name: "Status", selector: (row) => row.isActive, sortable: true, align: 'text-start' },
        { name: "Action", selector: (row) => row.action, sortable: true, align: 'text-center' },
    ];


    const mappedData = () => {
        return gotraMasterList.map((item, index) => ({
            sn: index + 1,
            gotraName: item.gotraName || '-',
            isActive: (
                <span
                    className={`badge rounded-pill px-3 py-2 fw-semibold d-inline-flex align-items-center fs-1rem ${item.isActive === 1
                        ? 'bg-light-success text-success'
                        : 'bg-light-danger text-danger'
                        }`}
                >
                    {item.isActive === 1 ? (
                        <>
                            <FaCheckCircle className="me-1" />
                            Active
                        </>
                    ) : (
                        <>
                            <FaTimesCircle className="me-1" />
                            Inactive
                        </>
                    )}
                </span>
            ),
            action: (
                <>
                    <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => { handleEdit(item) }}
                        title="Edit Gotra"
                        disabled={item.isActive === 0}
                    >
                        <FaEdit />
                    </button>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => { handleDelete(item) }}
                        title="Delete Gotra"
                        disabled={item.isActive === 0}
                    >
                        <FaTrash />
                    </button>
                </>
            )
        }))
    }

    const handleAddGotra = () => {
        setEditMode(false);
        setEditData(null);
        setOpenModal(true);
    };

    const handleEdit = async (item) => {
        setEditMode(true);
        const response = await getGotraById(item.gotraId);
        if (response) {
            setEditData(response);
            setOpenModal(true);
        } else {
            Swal.fire("Error", "Failed to fetch Gotra details", "error");
        }
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const isEdit = !!editData;
            const payload = {
                gotraName: values.gotraName,
                isActive: 1,
                ...(isEdit
                    ? {
                        gotraId: editData.gotraId,
                        modifiedBy: loginId,
                        modifiedDate: new Date().toISOString(),
                    }
                    : {
                        createdBy: loginId,
                        createdDate: new Date().toISOString(),
                    })

            };
            if (editData) {
                // EDIT
                const confirm = await AlertConfirmation({ title: "Are you sure to update!", message: '' });
                if (!confirm) return;
                const result = await updateGotra(editData?.gotraId, payload);
                if (result) {
                    Swal.fire("Updated", "Gotra updated successfully", "success");
                    fetchGotraList();
                } else {
                    Swal.fire("Error", "Failed to update nakshatra", "error");
                }
            } else {
                // ADD
                const confirm = await AlertConfirmation({ title: "Are you sure to add!", message: '' });
                if (!confirm) return;
                const result = await createGotra(payload);
                if (result) {
                    Swal.fire("Added", "Gotra created successfully", "success");
                    fetchGotraList();
                } else {
                    Swal.fire("Error", "Failed to create gotra", "error");
                }
            }
            resetForm();
            setOpenModal(false);
            setEditMode(false);
            setEditData(null);
        } catch (error) {
            Swal.fire("Error", "Something went wrong", "error");
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (item) => {
        if (!item.gotraId) {
            Swal.fire("Error", "Failed to Delete Gotra", "error");
            return;
        }
        const confirm = await AlertConfirmation({ title: "Are you sure to delete!", message: '' });
        if (!confirm) return;
        const result = await deleteGotra(item.gotraId);
        if (result) {
            Swal.fire("Deleted", "Gotra deleted successfully", "success");
            fetchGotraList();
        } else {
            Swal.fire("Error", "Failed to delete gotra", "error");
        }
    };


    return (
        <div className="card">
            <Navbar />
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h3 className="admin-custom-heading">Gotra Master List</h3>
                    </div>
                </div>
            </div>
            <div id="card-body customized-card" className="p-2">
                {<Datatable columns={columns} data={mappedData()} />}
            </div>
            <div className="text-center mb-3">
                <button type="submit" className="add" onClick={handleAddGotra}>
                    Add New
                </button>
            </div>


            {openModal && (
                <div className="modal show d-block cs-modal-bg" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header bg-warning">
                                <h5 className="modal-title">{editMode ? "Edit Gotra" : "Add New Gotra"}</h5>
                                <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <Formik
                                    enableReinitialize
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    <Form>
                                        <div className="row g-3 align-items-center">
                                            <div className="col-md-12">
                                                <label className="form-label">Gotra Name</label>
                                                <Field type="text" name="gotraName" className="form-control" />
                                                <ErrorMessage name="gotraName" component="div" className="text-danger small" />
                                            </div>
                                        </div>
                                        <div className="text-center mt-4">
                                            <button type="submit" className="submit me-2">{editMode ? `Update` : `Submit`}</button>
                                            <button type="button" className="back" onClick={() => setOpenModal(false)}>Cancel</button>
                                        </div>
                                    </Form>
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
};

export default GotraMasterListComponent;